import React from 'react';
import { useGetBlogPostsQuery } from '../../../redux/slices/blogPostSlice';

import BlogPostTease from './BlogPostTease';

import styles from './Blog.module.postcss';

function FeaturedBlogPosts({ title, count = 2, categoryId }) {
  const { data = {} } = useGetBlogPostsQuery({
    published: true,
    page_size: count,
    ...(categoryId && { blog_category_id: categoryId })
  });
  const blogPosts = data.blog_posts || [];

  if (!blogPosts || blogPosts.length < 1) {
    return null;
  }

  return (
    <div className={styles.FeaturedPosts}>
      <h2>{ title || 'Recent Posts'}</h2>
      <div className={styles.FeaturedPosts_list}>
        { blogPosts.map((blogPost) => {
          return (
            <BlogPostTease blogPost={blogPost} key={blogPost.id} />
          );
        })}
      </div>
    </div>
  );
}

export default FeaturedBlogPosts;
